import { createCustomSwiper, createSwiperProductBlocks, _t, isMobile } from '../base.js'
import { initRatings } from './ratings.js'
import { addHpBlog } from '../blog/blog.js'
import { createBannerSection } from '../global.js'

function createCarousel() {
    const carousel = document.querySelector('#carousel')

    if (!carousel) return

    // Initialize swiper with a delay to ensure rendering
    setTimeout(() => {
        createCustomSwiper('#carousel .carousel-inner', {
            swiperClass: 'hp-carousel',
            pagination: true,
            arrows: false,
            customOptions: {
                loop: false,
                spaceBetween: 20,
                slidesPerView: 1.1,
                preloadImages: true,
                updateOnImagesReady: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                observer: true,
                observeParents: true,
                initialSlide: 0,
                speed: 600, // Slower transition to help with rendering
                breakpoints: {
                    768: {
                        slidesPerView: 2.5,
                    },
                    992: {
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },
                },
            },
        })
    }, 200)
}

function addProductsGroupBtn() {
    const groupTitles = document.querySelectorAll('.homepage-group-title')

    groupTitles.forEach((group) => {
        const [title, url, btnText] = group.innerText.split(';')

        if (url) {
            const buttonHTML = /* HTML */ `
                <div class="text-center group-btn-margin">
                    <a href="${url.trim()}" class="btn btn-secondary group-products-btn">
                        ${btnText ? btnText : _t('product.showMoreBtn')}
                    </a>
                </div>
            `
            group.nextElementSibling.nextElementSibling
                .querySelector('.swiper-navigation')
                .insertAdjacentHTML('afterend', buttonHTML)

            group.innerText = title.trim()
        }
    })
}

function adjustBannerHeight() {
    const banners = document.querySelectorAll('.hp-middle-banners__item')

    if (banners.length === 0) return
    if (isMobile()) return

    banners.forEach((banner) => {
        const bannerHeight = banner.querySelector('img').height
        banner.querySelector('.hp-middle-banners__item-content').style.height = bannerHeight + 'px'
    })
}

function categories() {
    if ($('.section-1').length) {
        $('.able-hp-categories').insertAfter($('.section-1'))
    } else {
        $('.able-hp-categories').insertAfter($('.hp-middle-banners'))
    }
}

function addMiddleBanners() {
    const middleBanners = $('footer .hp-middle-banners')

    $(middleBanners).insertAfter($('.able-brands-banners'))
}

export function initHomepage() {
    createCarousel()
    createSwiperProductBlocks()
    addMiddleBanners()
    addProductsGroupBtn()
    adjustBannerHeight()
    categories()
    initRatings()

    // addHpBlog(4)
}
